export enum DomainStatus {
    Verified = 'verified',
    UnVerified = 'unverified',
    Pending = 'pending',
    Active = 'active',
    Stopped = 'stopped',
    Rejected = 'rejected'
}
